import {useMouse as _useMouse, createSharedComposable} from '@vueuse/core'

export const useMouse = createSharedComposable(_useMouse)
